import * as S from "./cmpSignPageContent.styles";
import * as T from "../CmpCarInfoContent/cmpCarInfoContent.styles";
import { Button } from "../../../atoms/Buttons";
import { ReactComponent as IconArrowLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconArrowRight } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { ReactComponent as IconAgree } from "../../../../styles/assets/svg/icon-agree.svg";
import { ReactComponent as IconAgreeFalse } from "../../../../styles/assets/svg/icon-agree-false.svg";
import React, { useState } from "react";

interface CmpSignPageContentProps {
  onNextStepHandler: () => void;
  onBackHandler: () => void;
  setIsCheck: React.Dispatch<React.SetStateAction<boolean>>;
  isCheck: boolean;
}

export const CmpSignPageContent = ({
  onNextStepHandler,
  onBackHandler,
  setIsCheck,
  isCheck,
}: CmpSignPageContentProps) => {
  return (
    <S.ContentsSection>
      <S.ContentHeader>
        <S.ContentsTit>
          <S.ContentsState>8 / 9 단계</S.ContentsState>
          <span>운송기사 자격등록</span>
        </S.ContentsTit>
        <S.TextSize>
          <S.BlueText>지입계약서</S.BlueText>에<br />
          서명해 주세요
        </S.TextSize>
      </S.ContentHeader>
      <S.ContentMainLayout>
        <S.Alterdiv>모든 정보를 읽고 서명해 주세요.</S.Alterdiv>
        <S.ScrollableBoxContainer>
          <S.FixedAreaTop>지입 계약서</S.FixedAreaTop>
          <S.ScrollableArea>
            <div>
              <p>
                운송회사 (주)ㅇㅇㅇ(이하 "갑"이라 칭한다)와 화물차량 보유자
                ㅇㅇㅇ(이하 "을"이라 칭한다)는 상호간에 다음과 같이 화물차 지입
                계약을 체결한다.
              </p>
            </div>
            <div>
              <p>
                1. 임대물건: 임대인은 임차인에게 [임대물건의 주소]에 위치한
                [임대물건의 설명]을 임대합니다.
              </p>
            </div>
            <div>
              <p>2. 임대기간: 이 계약은 [임대기간]에 걸쳐 유효합니다.</p>
            </div>
            <div>
              <p>
                3. 임대료 및 기타 비용: 임차인은 매월 [임대료]를 임대인에게
                지불해야 합니다.
              </p>
            </div>
            <div>
              <p>
                4. 보증금: 임차인은 [보증금]을 임대인에게 지불해야 합니다.
                보증금은 임대기간 종료 시 환급됩니다.
              </p>
            </div>
            <div>
              <p>5. 기타 조항: [기타 조항 및 특별 사항을 여기에 기입합니다.]</p>
            </div>
            <div>
              <p>이상으로 본 계약이 체결되었습니다.</p>
            </div>
            <div>
              <p>임대인: [임대인 서명] 임차인: [임차인 서명]</p>
            </div>
            <div>
              <p>날짜: [계약 체결 날짜]</p>
            </div>
            <div>
              <p>
                운송회사 (주)ㅇㅇㅇ(이하 "갑"이라 칭한다)와 화물차량 보유자
                ㅇㅇㅇ(이하 "을"이라 칭한다)는 상호간에 다음과 같이 화물차 지입
                계약을 체결한다.
              </p>
            </div>
            <div>
              <p>
                1. 임대물건: 임대인은 임차인에게 [임대물건의 주소]에 위치한
                [임대물건의 설명]을 임대합니다.
              </p>
            </div>
            <div>
              <p>2. 임대기간: 이 계약은 [임대기간]에 걸쳐 유효합니다.</p>
            </div>
            <div>
              <p>
                3. 임대료 및 기타 비용: 임차인은 매월 [임대료]를 임대인에게
                지불해야 합니다.
              </p>
            </div>
            <div>
              <p>
                4. 보증금: 임차인은 [보증금]을 임대인에게 지불해야 합니다.
                보증금은 임대기간 종료 시 환급됩니다.
              </p>
            </div>
            <div>
              <p>5. 기타 조항: [기타 조항 및 특별 사항을 여기에 기입합니다.]</p>
            </div>
            <div>
              <p>이상으로 본 계약이 체결되었습니다.</p>
            </div>
            <div>
              <p>임대인: [임대인 서명] 임차인: [임차인 서명]</p>
            </div>
            <div>
              <p>날짜: [계약 체결 날짜]</p>
            </div>
            <div>
              <p>
                운송회사 (주)ㅇㅇㅇ(이하 "갑"이라 칭한다)와 화물차량 보유자
                ㅇㅇㅇ(이하 "을"이라 칭한다)는 상호간에 다음과 같이 화물차 지입
                계약을 체결한다.
              </p>
            </div>
            <div>
              <p>
                1. 임대물건: 임대인은 임차인에게 [임대물건의 주소]에 위치한
                [임대물건의 설명]을 임대합니다.
              </p>
            </div>
            <div>
              <p>2. 임대기간: 이 계약은 [임대기간]에 걸쳐 유효합니다.</p>
            </div>
            <div>
              <p>
                3. 임대료 및 기타 비용: 임차인은 매월 [임대료]를 임대인에게
                지불해야 합니다.
              </p>
            </div>
            <div>
              <p>
                4. 보증금: 임차인은 [보증금]을 임대인에게 지불해야 합니다.
                보증금은 임대기간 종료 시 환급됩니다.
              </p>
            </div>
            <div>
              <p>5. 기타 조항: [기타 조항 및 특별 사항을 여기에 기입합니다.]</p>
            </div>
            <div>
              <p>이상으로 본 계약이 체결되었습니다.</p>
            </div>
            <div>
              <p>임대인: [임대인 서명] 임차인: [임차인 서명]</p>
            </div>
            <div>
              <p>날짜: [계약 체결 날짜]</p>
            </div>
          </S.ScrollableArea>
          {/* <S.FixedAreaFoot>사용자 서명</S.FixedAreaFoot> */}
        </S.ScrollableBoxContainer>
        {/* <S.ButtonContainer> */}
        {/* <S.SignButton>
          <IconCamera name="camera" width="25px" height="25px" fill="#1D4ED7" />
          계약서명
        </S.SignButton> */}
        {/* </S.ButtonContainer> */}
        <S.AgreementPageCheckBox
          className={isCheck ? "active" : ""}
          onClick={() => setIsCheck(!isCheck)}
        >
          {isCheck ? <IconAgree /> : <IconAgreeFalse />}
          <p> 위 약관에 동의합니다. </p>
        </S.AgreementPageCheckBox>
      </S.ContentMainLayout>

      <T.CmpButtonBox>
        <div className="small">
          <Button
            label="이전"
            type="button"
            color="transparent"
            size="full"
            onClick={onBackHandler}
          >
            <IconArrowLeft width={20} height={20} />
          </Button>
        </div>
        <Button
          type="button"
          color="primary"
          size="full"
          onClick={onNextStepHandler}
          disabled={!isCheck}
        >
          다음
          <IconArrowRight width={20} height={20} />
        </Button>
      </T.CmpButtonBox>
    </S.ContentsSection>
  );
};
